export const CARD_PATTERN = /Card Ending\s*:\s*\d{4}\s*-\s*Payment Taken\s*\[£([\d,.]+(?:\.\d{1,2})?)\]\s*On\s*(\d{2}\/\d{2}\/\d{4})/;
export const VA_PATTERN = /VirtualAssistant Ending\s*:\s*\d{4}\s*-\s*Payment Taken\s*\[£([\d,.]+)\]\s*On\s*(\d{2}\/\d{2}\/\d{4})/;
export const CHIP_PIN_PATTERN = /Chip & Pin Ending\s*:\s*\d{4}\s*-\s*Payment Taken\s*\[£([\d,.]+)\]\s*On\s*(\d{2}\/\d{2}\/\d{4})/;
export const PREV_PAYMENTS_PATTERN = /PREVIOUSPAYMENTS Ending\s*:\s*\d{4}\s*-\s*Payment Taken\s*\[£([\d,.]+)\]\s*On\s*(\d{2}\/\d{2}\/\d{4})/;
export const PAYPAL_PATTERN = /(?:Card Ending:\s*PayPal\s*-\s*Payment Taken\s*\[£([\d,.]+)\]\s*On\s*(\d{2}\/\d{2}\/\d{4})|Paypal Ending\s*:\s*\d{4}\s*-\s*Payment Taken\s*\[£([\d,.]+)\]\s*On\s*(\d{2}\/\d{2}\/\d{4}))/i;
export const CREDIT_CARD_PATTERN = /CREDIT CARD(?: \(PDQ\))? Payment (?:Made On\s*-\s*(\d{2}\/\d{2}\/\d{4})|Taken\s*\[£([\d,.]+)\]\s*On\s*(\d{2}\/\d{2}\/\d{4}))/i;
export const CARD_TERM_OR_PDQ_PATTERN = /CARD (TERM|PDQ) Payment Made On\s*-\s*(\d{2}\/\d{2}\/\d{4})/;
export const VSP_PATTERN = /VSP Payment Made On\s*-\s*(\d{2}\/\d{2}\/\d{4})/;
export const CASH_PATTERN = /(?:Cash Ending\s*:\s*\d{4}\s*-\s*Payment Taken|CASH Payment Taken)\s*\[£([\d,.]+)\]\s*On\s*(\d{2}\/\d{2}\/\d{4})/i;

export const CARD_NAME = "Card";
export const VA_NAME = "Virtual Assistant";
export const CHIP_PIN_NAME = "Chip & Pin";
export const PREV_PAYMENT_NAME = "Previous Payments";
export const PAYPAL_NAME = "PayPal";
export const CREDIT_CARD_NAME = "Credit Card";
export const VSP_NAME = "VSP";
export const CASH_NAME = "Cash"; 


// WEBPACK FOOTER //
// ./src/parts/Basket/TransactionHystory/transactionConstants.js